import { gsap } from "gsap/all";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Observer } from "gsap/Observer";

import hideOnScroll from "hide-on-scroll";
gsap.registerPlugin((ScrollTrigger, Observer));
//
//
// GSAP DEFAULTS SEETIS
///  ------ ------ ------ ------ ------ ------ ------ ------ ------ ------
var markers = false;
gsap.config({
  nullTargetWarn: false,
});
gsap.defaults({
  ease: "none",
});
ScrollTrigger.config({
  limitCallbacks: false,
  immediateRender: false,

  markers: markers,
});
//
//
//
/************************************ CHANGE ACCENT COLOR ON EVERY PAGE  ******************************************************************** */
export function changeColor(stage) {
  const colorEL = document.getElementById("wordEl");
  var ease = "power4.inOut";
  switch (stage) {
    case "homepage":
      var value = "#ffffff";
      animChangeColor(value, 0);
      break;
    case "potfolio":
      var value = "#651CFF";
      animChangeColor(value, 1);
      break;
    case "testimonial":
      var value = "#ffc403";
      animChangeColor(value, 0.6);
      break;
    case "team":
      var value = "#5CF5FF";
      animChangeColor(value);
      break;
    case "contact":
      var value = "#ffc403";

      //#ffc403
      animChangeColor(value, 1);
      break;
  }

  function animChangeColor(value, opacity) {
    var rgb = gsap.utils.splitColor(value);

    var colortime = new gsap.timeline({
      onStart: () => {},
    }).to(colorEL, {
      background: value,
      duration: 3,
      opacity: opacity,
      ease: "power4.out",
    });
  }
}

//
/************************************ GSAP ANIMATION FUNCTIONS  ******************************************************************** */
/************************************ GSAP ANIMATION FUNCTIONS  ******************************************************************** */
/************************************ GSAP ANIMATION FUNCTIONS  ******************************************************************** */
export function sudopAnimations(stage) {
  //
  var ease = "power4.inOut";
  let x = 0;
  let y = 0;

  // KILL ALL SCROLLTRIGGERS
  ScrollTrigger.killAll();

  /************************************ ANOTHER ANIMATION on scroll  ******************************************************************************************************** */
  const animWhiteScroll = [...document.querySelectorAll("[animTexty]")];
  const storySection = document.querySelectorAll("[data-section-story]");
  const btnAnim = document.querySelectorAll("[animButton]");
  const comname = document.querySelectorAll(
    "[data-section-story] .company-name"
  );
  btnAnim.forEach((el) => {
    var compnaAnim = gsap
      .timeline({
        paused: true,
        scrollTrigger: {
          trigger: el,
          start: "bottom bottom-=5%",
          end: "top top",
          markers: false,
          once: false,
          scrub: false,
        },
      })
      .fromTo(
        el,
        {
          ease: "power4.Out",
          duration: 0.8,
          opacity: 0,
          x: 20,
        },
        { opacity: 1, x: 0 }
      );
  });
  comname.forEach((el) => {
    var compnaAnim = gsap
      .timeline({
        paused: true,
        scrollTrigger: {
          trigger: el,
          start: "bottom bottom",
          end: "top center+=25%",
          markers: false,
          once: false,
          scrub: false,
        },
      })
      .fromTo(
        el,
        {
          ease: "power4.Out",
          duration: 1,
          opacity: 0,
          x: 20,
          filter: "blur(2px)",
        },
        { opacity: 1, x: 0, duration: 1, filter: "blur(0px)" }
      );
  });

  animWhiteScroll.forEach((el) => {
    var p = el.querySelector("p");
    var h2 = el.querySelector("h2");
    var duration = 0.8;

    var animSplit = gsap
      .timeline({
        defaults: { ease: "none", duration: duration },
        paused: true,
        scrollTrigger: {
          trigger: el,

          start: "top bottom",
          end: "top center",
          markers: false,
          once: false,
          scrub: false,
        },
      })
      .fromTo(
        h2,
        {
          opacity: 0,
          ease: "power4.Out",
          duration: duration,
          filter: "blur(5px)",
        },
        { opacity: 1, filter: "blur(0px)" }
      )

      .fromTo(
        p,
        {
          duration: duration / 3,
          overwrite: true,
          x: 30,
          filter: "blur(5px)",
          opacity: 0.5,
        },
        { duration: duration / 3, filter: "blur(0px)", x: 0, opacity: 1 },
        "<"
      )
      .fromTo(
        el,
        {
          y: 20,
          duration: duration / 2,
        },
        { y: 0, duration: duration / 2 },
        "<"
      );
  });
  /************************************ HERO CUBE ANIMATION  ******************************************************************************************************** */
  //
  //
  const cubeTrigger = document.getElementById("cubeTrigger");
  const cubeTriggerLong = document.getElementById("longTrigger");
  const cubeVar = document.getElementById("cubeVar");
  const cubeBlur = document.getElementById("cubeBlur");
  const cubeShadow = document.getElementById("cubeShadow");
  window.addEventListener("resize", (event) => {
    ScrollTrigger.update();
  });
  if (cubeTrigger) {
    var cubeAnim = gsap.timeline({
      defaults: { ease: "power4.out", duration: 2 },

      scrollTrigger: {
        trigger: cubeTrigger,

        start: "top top-=50px",

        end: "bottom center",
        markers: false,
        once: true,
        scrub: false,
      },
    });
    cubeAnim
      .fromTo(cubeVar, { "--gap": 20 }, { "--gap": 2 }, "<")
      // .fromTo(cubeBlur, { filter: "blur(20px)" }, { filter: "blur(0px)" }, "<")
      .fromTo(cubeShadow, { opacity: 0 }, { opacity: 0.25 }, "<");

    var cubeAnim2 = gsap.timeline({
      defaults: { ease: "none", duration: 1 },

      scrollTrigger: {
        trigger: document.body,

        start: "top top",

        end: "top top-=" + window.innerHeight * 1.3 + "px",
        markers: false,
        once: false,
        scrub: true,
      },
    });
    cubeAnim2.fromTo(
      cubeVar,
      { rotateY: "10deg", rotateX: "-25deg", rotateZ: "-10deg" },
      { rotateY: "45deg", rotateX: "-25deg", rotateZ: "-10deg" },
      "<"
    );
  }

  /************************************ OLD HERO ANIMATION  ******************************************************************************************************** */
  // const heroImg = document.getElementById("heroImage");

  // if (heroImg) {
  //   var heroimgAnim = gsap.timeline({
  //     defaults: { ease: "none", duration: 1 },

  //     scrollTrigger: {
  //       trigger: heroImg,

  //       start: "center bottom",

  //       end: "bottom top",
  //       markers: false,
  //       once: false,
  //       scrub: true,
  //     },
  //   });
  //   heroimgAnim.fromTo(
  //     heroImg.children,
  //     {
  //       scale: 1,
  //     },
  //     { scale: 1.2 }
  //   );
  // }

  /************************************ BIG IMAGE ANIMATION  ******************************************************************************************************** */

  const bigImg = document.querySelectorAll(".bigImg img");

  bigImg.forEach((el) => {
    console.log();
    var bigImgAnim = gsap.timeline({
      defaults: { ease: "none", duration: 1 },

      scrollTrigger: {
        trigger: el,

        start: "top bottom",

        end: "bottom top",
        markers: false,
        once: false,
        scrub: true,
      },
    });
    bigImgAnim.fromTo(
      el.children,
      {
        scaleX: 1.2,

        rotationY: 0,
      },
      { scaleX: 1, rotationY: 3 }
    );
  });

  //
  //
  /************************************ PARALLAX ANIM  ******************************************************************************************************** */
  //
  //
  const parralaxZoom = document.querySelectorAll("[zoom]");

  parralaxZoom.forEach((el) => {
    console.log();
    var parallaxZoomAnim = gsap.timeline({
      defaults: { ease: "none", duration: 1 },

      scrollTrigger: {
        trigger: el,

        start: "top bottom",

        end: "bottom bottom-=" + window.innerHeight + "px",
        markers: false,
        once: false,
        scrub: true,
      },
    });
    parallaxZoomAnim.fromTo(
      el,
      {
        scale: 1.2,
      },
      { scale: 1 }
    );
  });
  //
  //
  //
  /************************************ SCROLL OBSERVER  ******************************************************************************************************** */
  function wheelObserver(state, value) {
    //

    const topNav = document.getElementById("header");
    const navEl = document.querySelector("nav");

    ////////////////////////////////////////////////
    // MENU observer
    ANIM.wheelObserve = new Observer.create({
      target: window,
      wheelSpeed: -1,
      type: "wheel,touch",

      onDown: () => {
        if (!ANIM.topNav.isActive() && topNav.classList.contains("hidden")) {
          ANIM.topNav.timeScale(1).reverse();
        }
      },
      onUp: () => {
        if (!ANIM.topNav.isActive() && topNav.classList.contains("hidden")) {
          ANIM.topNav.play();
        }
      },
      tolerance: 10,
    });

    ANIM.topNav = gsap.timeline({
      defaults: { ease: ease },

      scrollTrigger: {
        trigger: topNav,
        start: "top top",
        end: "bottom top",

        once: false,
        scrub: true,
        onLeave: (self) => {
          topNav.classList.add("isHide");
          hideOnScroll({
            navbarSelector: ".isHide",
            hidingClass: "keep",
          });
        },
        onLeaveBack: () => {
          if (topNav.classList.contains("isHide")) {
            topNav.classList.remove("isHide");
          }
        },
      },
    });
  }

  //
  //
  //
  /************************************ CURSOR OBRSERVER  ************************************************************************************************* */
  function followCursor(state) {
    //

    if (state && !APP.TOUCH.isMobile) {
      function lerp(start, end, amt) {
        return (1 - amt) * start + amt * end;
      }

      let cursor = [];
      const canvasToMove = document.getElementById("wordEl");

      ANIM.mouseObserver = new Observer.create({
        target: window,
        wheelSpeed: -1,
        type: "pointer",
        onMove: (mouse) => {
          cursor.x = mouse.x - window.innerWidth / 2;
          cursor.y = mouse.y - window.innerHeight / 2;
          cursor.delta = mouse.deltaY;

          gsap.to(canvasToMove, {
            duration: 5,

            x: cursor.x,
            y: cursor.y,
            stagger: 2,
            ease: "power5.out",
          });
        },

        tolerance: 10,
      });
    }
  }

  followCursor(true);
  wheelObserver(true);
}
/************************************ START IT ***************************** */
/************************************ FIRST ENTER TO PAGE ANIMATION ***************************** */
export function afterLoadedAnims(loaded) {
  const curtain = document.getElementById("pageTransitionCurtain");
  const introLogo = document.getElementById("logoIntro");
  const headline = document.getElementById("headline");

  const curtainSpot = document.getElementById("curtainSpot");
  //

  ANIM.fadeLogo = new gsap.timeline({
    paused: true,

    onComplete: () => {
      introLogo.classList.add("loaded");
    },
    defaults: { ease: "power4.out", duration: 1.2 },
  })
    .to(introLogo, { opacity: 0 })
    .to(
      curtainSpot,

      { opacity: 0, scale: 0.2 },
      "<"
    )
    .fromTo(
      headline,

      {
        opacity: 0,
        y: window.innerHeight / 10,
        filter: "blur(5px)",
        duration: 1.8,
        ease: "power4.out",
      },
      {
        opacity: 1,
        y: 0,
        filter: "blur(0px)",
        ease: "power4.out",
        duration: 1.8,
      },
      "<"
    );

  ANIM.curtainAnim = new gsap.timeline({
    paused: true,
    onStart: () => {},
    defaults: { ease: "power4.out", duration: 1.6, delay: 0.3 },
  }).to(
    curtain,

    { height: 0 }
  );

  //
  new gsap.timeline({
    onComplete: () => {
      document.body.classList.add("ready");
      ANIM.curtainAnim.play();
      ANIM.fadeLogo.play();
    },
    defaults: { ease: "power2.out", duration: 1.58, force3d: true },
  }).to(introLogo, { filter: "blur(0px)", scale: 1.1 });
}
